module.exports = __webpack_public_path__ + "img/film-threat-optimization-2.7d7404a1.svg";